import React, { FC } from 'react';
import { IDictionary } from '@constants/languages/types';
import './styles.scss';

interface IPhysicianLocationProps {
  dictionary: IDictionary;
  physicianLocation: string;
}

export const PhysicianLocation: FC<IPhysicianLocationProps> = ({
  dictionary,
  physicianLocation,
}) => (
  <div className="continer">
    <span className="content-label">{`${dictionary.labels.location}: `}</span>
    <span className="content-value">{physicianLocation}</span>
  </div>
);
